import { t } from '@gem/modules/i18n';

import { getTtlPeriodText } from 'APP/main/ChatView/ChatAutoCleanupSettings/ChatAutoCleanupSettings.utils';
import { ChatAutoCleanupSettingsPopup } from 'APP/main/PopupManager/Popups/ChatAutoCleanupSettingsPopup/ChatAutoCleanupSettingsPopup';
import Entities from 'STORE';

import { openPopup, showAlert } from '../../app/app';

export function openAutoCleanupSettings(groupId: string): boolean {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return false;
  }

  if (group.isP2P || group.isOwner || group.isAdmin) {
    openPopup(ChatAutoCleanupSettingsPopup, {
      params: {
        groupId: groupId,
      },
    });
    return true;
  }

  let alertText = t('chat_auto_cleanup_no_permission_disabled_description');

  if (group.ttlPeriodMs) {
    alertText = t('chat_auto_cleanup_no_permission_enabled_description', {
      0: `<strong>${getTtlPeriodText(group.ttlPeriodMs)}</strong>`,
      interpolation: { escapeValue: false },
    });
  }

  showAlert({
    title: t('chat_auto_cleanup_title'),
    primaryText: t('common_ok'),
    hasCloseButton: true,
    html: alertText,
  });
  return true;
}
